import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { persistedState, saveState } from "./persisted.store.js";
import { me } from "./auth.slice";

import rootReducer from "./reducers";
import { AUTH_TOKEN } from "constants/SiteConstants";

function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: rootReducer,
    middleware: [...getDefaultMiddleware()],
    preloadedState,
  });

  if (process.env.NODE_ENV !== "production" && module.hot) {
    module.hot.accept("./reducers", () => store.replaceReducer(rootReducer));
  }

  return store;
}

const store = configureAppStore(persistedState);
store.subscribe(() => {
  saveState(store.getState());
});
if (localStorage.getItem(AUTH_TOKEN)) {
  store.dispatch(me());
}
export default store;
